import React, { useState, useMemo } from 'react';
import styles from './batch-update.module.css'; // Reusing styles for consistency

const ExportBrandDrawerContent = ({ brands, onExport, isExporting, onClose }) => {
    const [selectedBrands, setSelectedBrands] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const filteredBrands = useMemo(() => {
        if (!searchTerm) return brands;
        return brands.filter(b => 
            b.label.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [brands, searchTerm]);

    const handleToggleBrand = (brandId) => {
        setSelectedBrands(prev => 
            prev.includes(brandId) 
                ? prev.filter(id => id !== brandId) 
                : [...prev, brandId]
        );
    };

    const handleSelectAll = () => {
        setSelectedBrands(filteredBrands.map(b => b.id));
    };

    const handleDeselectAll = () => {
        setSelectedBrands([]);
    };

    const handleGenerate = () => {
        if (selectedBrands.length === 0) return;
        onExport(selectedBrands.join(","));
    };

    return (
        <div className={styles.container} style={{ minHeight: '400px', display: 'flex', flexDirection: 'column' }}>
            <h2 className={styles.title}>Export Price History</h2>
            <p className={styles.subtitle}>Select one or more brands to generate a complete Excel report with margins and rankings.</p>

            <div className="mb-3 px-1">
                <input 
                    type="text" 
                    className="form-control rounded-pill" 
                    placeholder="Search brands..." 
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ height: '45px', paddingLeft: '20px' }}
                />
            </div>

            <div className="d-flex justify-content-between mb-2 px-1">
                <button className="btn btn-link btn-sm text-primary p-0" onClick={handleSelectAll}>Select All Visible</button>
                <button className="btn btn-link btn-sm text-secondary p-0" onClick={handleDeselectAll}>Clear Selection</button>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', border: '1px solid #eee', borderRadius: '8px', padding: '10px', marginBottom: '20px' }}>
                {filteredBrands.length === 0 ? (
                    <div className="text-center py-4 text-muted">No brands found</div>
                ) : (
                    filteredBrands.map((brand) => (
                        <div key={brand.id} className="form-check py-2 border-bottom d-flex align-items-center">
                            <input 
                                className="form-check-input" 
                                type="checkbox" 
                                id={`brand-${brand.id}`}
                                checked={selectedBrands.includes(brand.id)}
                                onChange={() => handleToggleBrand(brand.id)}
                                style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                            />
                            <label 
                                className="form-check-label ml-3 w-100" 
                                htmlFor={`brand-${brand.id}`}
                                style={{ cursor: 'pointer', fontWeight: selectedBrands.includes(brand.id) ? '600' : '400' }}
                            >
                                {brand.label}
                            </label>
                        </div>
                    ))
                )}
            </div>

            <div className="mt-auto d-flex gap-2">
                <button 
                    className="btn btn-outline-dark rounded-pill flex-grow-1 py-2"
                    onClick={onClose}
                    disabled={isExporting}
                >
                    Cancel
                </button>
                <button 
                    className="btn btn-dark rounded-pill flex-grow-1 py-2"
                    onClick={handleGenerate}
                    disabled={isExporting || selectedBrands.length === 0}
                >
                    {isExporting ? (
                        <>
                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                            Exporting...
                        </>
                    ) : `Generate Report (${selectedBrands.length})`}
                </button>
            </div>
        </div>
    );
};

export default ExportBrandDrawerContent;